<template>
    <div class="home">
        <v-container class="mb-11">
            <a ref="orderGeo" ></a>


            <br>
            <br>
            <h1>Заказы:</h1>
            <h2 v-if="!ordersAll.length && !globalLoading">Заказов нет</h2>

            <template v-if="globalLoading">
                <v-sheet
                        v-for="el in 5"
                        :key="el"
                        class="px-3 pt-3 pb-3"
                >
                    <v-skeleton-loader
                            class="mx-auto"
                            type="article"
                    ></v-skeleton-loader>
                </v-sheet>
            </template>

            <template v-show="!globalLoading">
                <v-card
                        v-for="el in ordersAll"
                        :key="el.id"
                        class="mx-auto ma-3"
                        max-width="700"
                >
                    <label :for="el.id">
                        <v-card-title>
                        <span>#{{el.order_id}}</span>

                        <v-chip v-if="el.state === 3"
                                                              class="ma-2"
                                                              color="red"
                                                              label
                                                              small
                                                              text-color="white"
                    >
                        <v-icon left>close</v-icon>
                        отменен
                    </v-chip>

                        <v-chip v-if="el.state === 2"
                                class="ma-2"
                                color="green"
                                label
                                small
                                text-color="white"
                        >
                            <v-icon left>done</v-icon>
                            выполнен
                        </v-chip>
                        <v-spacer></v-spacer>



                        <v-icon v-if="el.postponed===1">date_range</v-icon>
                        {{el.deliveryDate.delivery_date_h_i}}
                    </v-card-title>
                    </label>

                    <v-row no-gutters class="mb-2">
                        <v-col class="pl-3" :cols="(el.state === 1)? 10: 11">
                            <!--<span>{{el.address.city_name}}, {{el.address.asString}}</span>-->
                            <!--<br>-->
                            <span>
                                {{el.address.city_name}},
                                {{el.address.street}},
                                {{el.address.home}}
                                {{(el.address.entrance) ? `под. ${el.address.entrance},` : null}}
                                {{(el.address.floor) ? `эт. ${el.address.floor},` : null}}
                                {{(el.address.flat) ? `кв. ${el.address.flat}` : null}}
                            </span>
                        </v-col>
                        <v-col :cols="(el.state === 1)? 2: 1" >
                            <v-spacer></v-spacer>
                            <span>
                                <v-btn icon small :href="el.tel">
                                    <v-icon>phone_enabled</v-icon>
                                </v-btn>
                            </span>
                        </v-col>
                    </v-row>

                    <label :for="el.id">
                        <v-row no-gutters>
                        <v-col :cols="4">
                            <v-card class="pa-2 text-center" outlined >
                                <div class="text--primary">пакеты:</div>
                                <p class="display-1 text--primary mb-0">{{el.bag || 0}}</p>
                            </v-card>
                        </v-col>
                        <v-col :cols="4">
                            <v-card class="pa-2 text-center" outlined>
                                <div class="text--primary">пицца:</div>
                                <p class="display-1 text--primary mb-0">{{el.summaryData.pizza}}</p>
                            </v-card>
                        </v-col>
                        <v-col :cols="4">
                            <v-card class="pa-2 text-center" outlined>
                                <div class="text--primary">напитки:</div>
                                <p class="display-1 text--primary mb-0">{{el.summaryData.drinks}}</p>
                            </v-card>
                        </v-col>
                    </v-row>
                    </label>

                    <v-card-actions>
                        <div>
                            <div>
                                <span class="font-weight-black mr-1">К оплате:</span> {{el.payment.totalPayment}} ₽ ({{el.payment.typeName}})
                                <span v-if="(el.payment.totalPayment + el.payment.surrender) !== 0">
                                    <br>
                                Сдача с {{el.payment.totalPayment+el.payment.surrender}} ₽ = {{ el.payment.surrender}} ₽
                                </span>


                                <span v-if="el.address.comment.trim()"><br>
                            <b>Комментарий:</b> {{el.address.comment.trim()}}
                        </span>
                            </div>




                        </div>


                        <v-spacer></v-spacer>



                            <v-btn icon>
                                <label :for="el.id">
                                    <v-icon>{{ show[el.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                </label>

                                <input :id="el.id" type="checkbox" style="display: none" v-model="show[el.id]">
                            </v-btn>


                    </v-card-actions>

                    <v-expand-transition>
                        <div v-show="show[el.id]">
                            <v-divider></v-divider>

                            <v-card-text class="pa-0 ma-0">



                                <template>
                                    <v-container
                                    >
                                        <span
                                                v-for="card in el.categoryArr"
                                                :key="card.title"
                                        >
                                        <v-row no-gutters>
                                            <v-col>
                                                <v-card class="b-transparent" outlined>
                                                    <b>{{card.title}}:</b>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters
                                               v-for="(item, idx) in card.items"
                                               :key="idx"
                                        >
                                            <v-col cols="9">
                                                <v-card class="b-transparent" outlined>
                                                    {{item.dishName}}
                                                </v-card>
                                            </v-col>
                                            <v-col cols="1">
                                                <v-card class="b-transparent" outlined>
                                                    {{item.count}}
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-card class="b-transparent" outlined>
                                                   {{item.count*item.cost}}₽
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                        </span>
                                    </v-container>

                                </template>




                                <template>
                                    <v-simple-table dense >
                                            <tbody>
                                            <tr >
                                                <th class="text-left">
                                                    <span v-if="+el.payment.deliveryCost !== 0">
                                                        Доставка: {{el.payment.deliveryCost}} ₽
                                                    <br>
                                                    </span>

                                                    К оплате: {{el.payment.totalPayment}} ₽ ({{el.payment.typeName}})
                                                    <span v-if="(el.payment.totalPayment + el.payment.surrender) !== 0">
                                                       <br>
                                                        Сдача с {{el.payment.totalPayment+el.payment.surrender}} ₽ = {{el.payment.surrender}} ₽
                                                    </span>


                                                </th>
                                            </tr>
                                            </tbody>
                                    </v-simple-table>
                                </template>
                            </v-card-text>


                            <v-card-actions>
                                <template>


                                    <template v-if="el.state === 1">

                                            <v-btn
                                                    color="success"
                                                    dark
                                                    height="36"
                                                    width="69%"
                                                    @click="activeCard=el.order_id; order_id=el.id; sheet = !sheet"
                                            >
                                                выполнен
                                            </v-btn>
                                        <v-btn
                                                color="error"
                                                dark
                                                height="36"
                                                outlined
                                                width="29%"
                                                @click="sheetErr = !sheetErr; order_id=el.id; activeCard=el.order_id"
                                        >
                                            отменен
                                        </v-btn>


                                    </template>


                                </template>
                            </v-card-actions>

                        </div>
                    </v-expand-transition>
                </v-card>



                <v-bottom-sheet v-model="sheet">
                    <v-sheet class="text-center">
                        <div class="py-3 pt-5">
                            #{{activeCard}}
                            <br>
                            Подтвердить заказ?</div>
                        <v-btn
                                text
                                block
                                height="36"
                                color="success"
                                @click="()=>orderComplete({'order_id': activeCard, 'coords': position})"
                                :loading="loadingSheet"
                        >да</v-btn>
                        <div class="pb-15"></div>

                    </v-sheet>
                </v-bottom-sheet>

                <v-bottom-sheet v-model="sheetErr">
                    <v-list :disabled="loadingSheet">
                        <v-subheader> #{{activeCard}}<br>Причина:</v-subheader>
                        <v-list-item
                                v-for="el in reason"
                                @click="()=>orderCanceled({'order_id': activeCard, 'reason_id': el.id, 'coords': position})"
                        >
                            <v-list-item-title>{{ el.name }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-bottom-sheet>


            </template>

        </v-container>
    </div>
</template>

<script>

    export default {
        name: 'home',
        metaInfo: {
            title: 'Главная',
        },
        data: () => ({
            elShow: 0,
            activeCard: 0,
            show: {},
            sheet: false,
            sheetErr: false,
            loadingSheet: false,
            order_id: 0,
            position: '',
        }),

        methods: {
            toggleShow: function (id) {
                const {show} = this
                console.log('id', id);
                if (id in show) {
                    show[id] = !show[id]
                } else {
                    show[id] = false
                }
                console.log('show', show[id])
            },
            fetchOrders: async function () {
                await this.$store.commit('courier/setLoading', true)
                await this.$store.dispatch("courier/fetchOrders")
                await setTimeout(()=>{
                    this.$store.commit('courier/setLoading', false)
                }, 1)
            },
            orderComplete: async function (payload) {
                this.loadingSheet = true
                const rez = await this.$store.dispatch("courier/orderComplete", payload)
                this.$store.dispatch('courier/fetchReady')
                console.log('rez', rez);
                this.fetchOrders()
                this.loadingSheet = false
                this.sheet=false
            },
            orderCanceled: async function (payload) {
                this.loadingSheet = true
                const rez = await this.$store.dispatch("courier/orderCanceled", payload)
                this.$store.dispatch('courier/fetchReady')
                console.log('rez', rez);
                this.fetchOrders()
                this.loadingSheet = false
                this.sheetErr=false
            },
            getGeo: function(){
                const success = async ({coords}) => {
                    // получаем широту и долготу
                    const {latitude, longitude} = coords
                    let position = [latitude, longitude]
                    position = position.join(';');
                    this.position = position
                    await this.$store.dispatch("courier/placeCourier", position)
                }

                const error = ({ message }) => {
                    console.log('не удалось отправить гео', message) // при отказе в доступе получаем PositionError: User denied Geolocation
                }

                navigator.geolocation.getCurrentPosition(success, error, {
                    enableHighAccuracy: true
                })
            },
        },
        computed: {
            ordersAll() {
                const data = this.$store.getters["courier/orders"];
                const rez = []
                data.map(el=>{
                    const category = {}
                    const {items} = el
                    const summaryData = {
                        pizza: 0,
                        drinks: 0,
                        bags: 0,
                    }

                    items.map(el=>{
                        if(!category[el.category.categoryId]){
                            category[el.category.categoryId] = {
                                title: el.category.categoryName,
                                items: []
                            }
                        }
                        category[el.category.categoryId].items.push(el)
                        if (+el.category.categoryId === 5 || +el.category.station === 2){
                            summaryData.pizza += el.count
                        } else if (
                            el.category.code.includes('coff')
                            || el.category.code.includes('drink')
                            || el.category.code.includes('напит')
                        ){
                            summaryData.drinks += el.count
                        }
                    })
                    console.log(category);

                    rez.push({
                        ...el,
                        summaryData,
                        categoryArr: category,
                    })
                })
                return rez
            },
            reason() {
                return this.$store.getters["courier/reason"];
            },
            globalLoading() {
                return this.$store.getters["courier/loading"];
            },
        },
        watch: {
        },
        async mounted() {
          this.fetchOrders();
          this.$store.dispatch('courier/fetchReady')
          this.getGeo();

          //androidToken
            this.$store.dispatch("courier/registerToken", localStorage.getItem('androidToken'));

          setInterval(()=>{
              this.$store.dispatch("courier/fetchOrders")
              this.$store.dispatch('courier/fetchReady')
          }, 1000*10);
          setInterval(()=>{
              this.getGeo()
          }, 1000*5);


            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.register('./sw/geo.js')
                    .then((reg) => {
                        // регистрация сработала
                        console.log('======== Registration succeeded. Scope is ======== ' + reg);
                    }).catch((error) => {
                    // регистрация прошла неудачно
                    console.log('======== Registration failed with ========' + error);
                });
            }






        },
        destroyed(){
            navigator.serviceWorker.getRegistrations().then(function(registrations) {
                for(let registration of registrations) {
                    registration.unregister()
                } })
        },
    }
</script>
<style lang="scss" scoped>
    .b-transparent{
        border-color: transparent;
    }
</style>
